import { AppState } from '../../../redux/initialStates/AppState';
import { IPosOrderTypes } from '../initialStates/posOrderTypes';

export const selectPosOrderTypesState = (state: AppState): IPosOrderTypes => state.table.posOrderTypes;
